import { useConfig } from "../hooks/useConfig";

export const redirectToWeb = async (redirectUrl) => {
  const config = useConfig();
  if (!redirectUrl) {
    redirectUrl =
      config.env == "prd"
        ? "https://app.domuso.com"
        : `https://domusograilsweb-${config.env}.devmuso.com`;
  }
  const tokenForGrailsWeb = `Bearer ${localStorage.getItem("WEBAPP_ID_TOKEN")}`;

  await fetch(redirectUrl, {
    method: "GET",
    credentials: "include",
    headers: {
      Authorization: tokenForGrailsWeb,
    },
  }).then((response) => {
    window.location.href = redirectUrl;
  });
};
